import { render, staticRenderFns } from "./MarcasASeremCotadas.vue?vue&type=template&id=1084f87f&scoped=true"
import script from "./MarcasASeremCotadas.vue?vue&type=script&lang=js"
export * from "./MarcasASeremCotadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1084f87f",
  null
  
)

export default component.exports